import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { NotfoundComponent } from './shared/components/notfound/notfound.component';
import { LoginLayoutComponent } from './shared/components/layouts/login-layout/login-layout.component';
import { LoginComponent } from './modules/login/login.component';
import { ForgotpasswordComponent } from './modules/forgotpassword/forgotpassword.component';
import { RoleSelectComponent } from './modules/login-role-select/roleselect.component';
import { AuthGuard } from './core/guards/auth.guard';
import { ProductselectComponent } from './modules/productselect/productselect.component';

import { DashboardComponent } from './modules/dashboard/dashboard.component'
import { AdminLayoutComponent } from './shared/components/layouts/admin-layout/admin-layout.component';
import { MonitoringComponent} from './modules/monitoring/monitoring.component';
import { DevicemanagerComponent } from './modules/devicemanager/devicemanager.component';

 
const routes: Routes = [
  // App default redirect page
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },

  // App set/default Layout: Login layout
  {
    path: '',
    component: LoginLayoutComponent,
    children: [
      { path: 'login', component: LoginComponent},
      { path: 'forgotpassword', component: ForgotpasswordComponent},
      { path: 'role-select', component: RoleSelectComponent},
      { path: 'productselection', component: ProductselectComponent},  // , canActivate: [AuthGuard
    ]
  },

  // App set/default Layout: Admin/Dashboard layout
  {
  path: '',
    component: AdminLayoutComponent,
      children: [
      { path: 'dashboard', component: DashboardComponent },
      // { path: 'configure', loadChildren:'./modules/configure/configure.module#ConfigureModule'}, // , canActivate: [AuthGuard]
      { path: 'inventory', loadChildren:'./modules/inventory/inventory.module#InventoryModule'},// , canActivate: [AuthGuard]
      { path: 'history', loadChildren:'./modules/reports/reports.module#ReportsModule'}, // , canActivate: [AuthGuard]
      { path: 'monitoring', loadChildren: './modules/monitoring/monitoring.module#MonitoringModule'}, // , canActivate: [AuthGuard]
      { path: 'setup', loadChildren: './modules/platform-setup/platform-setup.module#PlatformSetupModule'}, // , canActivate: [AuthGuard]   

    ]
  },

  // App page not found redirect
  {
    path: '**',
    component: NotfoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
